import React, { useContext, useEffect, useState } from 'react';
import { Divider, Skeleton } from '@chakra-ui/react';
import { Flex, Text, Stack } from '@chakra-ui/layout';
import ExperiencesInProductListItem from './experiencesInProductListItem';
import { ProductContext } from '@/products/lib/productContext';
import { ProductPageContext } from '../lib/productPageContext';
import useExperienceApi from '@/experiences/lib/useExperienceApi';
import ExperienceGroupInProductListItem from './experienceGroupInProductListItem';
import { useSharedExperiencesApi } from '@/shared-experiences/lib/useSharedExperiencesApi';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import useInsightApi from '../../../insight/lib/useInsightApi';
import InsightTab from '../../../insight/components/insightTab';
import ExperiencesInProductListHeader from './experiencesInProductListHeader';
import ExperiencesInProductListMenu from './experiencesInProductListMenu';
import SharedExperienceTag from '@/components/sharedExperienceTag';
import useTranslation from '../../../lib/i18n/useTranslation';
export default function ExperiencesInProductList() {
  const { t } = useTranslation();
  const {
    productId,
    product,
    rights,
  } = useContext(ProductContext);
  const {
    refreshExperienceList,
    refreshPersonaList,
    refreshSharedExperienceList,
    isFetchingExperiences,
    experienceList,
    experienceGroupList,
    group,
    parentGroup,
  } = useContext(ProductPageContext);
  const [lists, setLists] = useState();
  const [hasList, setHasList] = useState(null);
  const [localList, setLocalList] = useState(null);
  const [draggingItem, setDraggingItem] = useState(null);
  const [fetchingInsights, setFetchingInsights] = useState(true);
  const insightApi = useInsightApi();
  const navigate = useNavigate();
  const experienceApi = useExperienceApi();
  const sharedExperiencesApi = useSharedExperiencesApi();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const groupId = searchParams.get('group-id')
  function compare(a, b) {
    if (a.order < b.order)
      return -1;
    if (a.order > b.order)
      return 1;
    return 0;
  }
  const updateOrderLocally = (item, destination) => {
    let newLocalList;
    const source = item.order;
    if (destination < source) {
      newLocalList = localList.map((e) => {
        if (
          e.order < source
          && e.order >= destination
          && e.id !== item.id
        ) {
          e.order++
        } else if (e.id === item.id) {
          e.order = destination;
        }
        return e;
      })
    } else if (destination > source) {
      newLocalList = localList.map(e => {
        if (e.order > source
          && e.order <= destination
          && e.id !== item.id) {
          e.order--;
        } else if (e.id === item.id) {
          e.order = destination;
        }
        return e;
      })
    } else if (destination === source) {
      newLocalList = Array.from(localList);
    }
    newLocalList.forEach(newLocalListItem => {
      newLocalListItem.hover = false;
    })
    newLocalList.forEach(newLocalListItem => {
      newLocalListItem.area = null;
    })
    newLocalList = newLocalList.sort(compare);
    setLocalList(newLocalList);
  };
  const getItemId = (draggingItem) => {
    if (draggingItem.type === 'products_experiences') {
      const relationId = draggingItem.data?.products_experiences_id || draggingItem.id;
      return relationId;
    } else if (draggingItem.type === 'product_experience_group') {
      return draggingItem.group_id;
    } else {
      return draggingItem.group_id;
    }
  };
  const orderAndMoveItems = async () => {
    try {
      let newLocalList = Array.from(localList);
      let lastItemHover;
      newLocalList.forEach((newLocalListItem) => {
        if (newLocalListItem.hover) {
          lastItemHover = newLocalListItem;
        }
      })
      
      if (lastItemHover && lastItemHover.id !== draggingItem.id) {
        if (lastItemHover.type === 'product_experience_group') {
          if (lastItemHover.area === 'middle') {
            if (draggingItem.type === 'products_experiences') {
              await experienceApi.moveExperienceToGroupInProduct(
                productId,
                draggingItem.data.id,
                lastItemHover.data.id
              );
              await refresh();
            } else if (draggingItem.type === 'product_experience_group') {
              await experienceApi.moveGroupToGroupInProduct(
                draggingItem.group_id,
                lastItemHover.data.id
              );
              await refresh();
            }
          } else {
            if (lastItemHover.area === 'border-top') {
              let newOrder;
              if (draggingItem.order < lastItemHover.order) {
                newOrder = lastItemHover.order - 1;
              } else {
                newOrder = lastItemHover.order;
              }
              await experienceApi.updateOrderInProduct(
                draggingItem.type,
                getItemId(draggingItem),
                newOrder
              );
              updateOrderLocally(draggingItem, newOrder);
            } else if (lastItemHover.area === 'border-bottom') {
              let newOrder;
              if (draggingItem.order > lastItemHover.order) {
                newOrder = lastItemHover.order + 1;
              } else {
                newOrder = lastItemHover.order;
              }
              await experienceApi.updateOrderInProduct(
                draggingItem.type,
                getItemId(draggingItem),
                newOrder
              );
              updateOrderLocally(draggingItem, newOrder);
            }
          }
        } else if (lastItemHover.type === 'products_experiences') {
          if (lastItemHover.area === 'border-top') {
            let newOrder;
            if (draggingItem.order < lastItemHover.order) {
              newOrder = lastItemHover.order - 1;
            } else {
              newOrder = lastItemHover.order;
            }
            await experienceApi.updateOrderInProduct(
              draggingItem.type,
              getItemId(draggingItem),
              newOrder
            );
            updateOrderLocally(draggingItem, newOrder);
          } else if (lastItemHover.area === 'border-bottom') {
            let newOrder;
            if (draggingItem.order > lastItemHover.order) {
              newOrder = lastItemHover.order + 1;
            } else {
              newOrder = lastItemHover.order;
            }
            await experienceApi.updateOrderInProduct(
              draggingItem.type,
              getItemId(draggingItem),
              newOrder
            );
            updateOrderLocally(draggingItem, newOrder);
          }
        }
      } else {
        newLocalList.forEach(newLocalListItem => {
          newLocalListItem.hover = false;
        })
        newLocalList.forEach(newLocalListItem => {
          newLocalListItem.area = null;
        })
        newLocalList = newLocalList.sort(compare);
        setLocalList(newLocalList);
      }
    } catch (error) {
      console.error('❌ [PRODUCT] Error in orderAndMoveItems:', error)
    }
  }
  const fetchInsights = async () => {
    try {
      setFetchingInsights(true);
      const result = await insightApi.fetchInsightSummaryListByProductId(productId, { groupId: group?.id })
      if (result) {
        setLists(result);
        let newHasList = false;
        for (const [key, value] of Object.entries(result)) {
          if (result[key] !== null) {
            newHasList = true;
          }
        }
        setHasList(newHasList)
      } else {
        setLists(null)
      }
      setFetchingInsights(false);
    } catch (error) {
      setLists(null)
      setFetchingInsights(false);
      console.error(error)
    }
  }
  const refresh = async () => {
    try {
      const values = await Promise.all([
        refreshExperienceList(),
        refreshPersonaList(),
      ])
    } catch (error) {
      console.error(error)
    }
  }
  const onDragEnd = async () => {
    try {
      await orderAndMoveItems();
      setDraggingItem(null);
    } catch (error) {
      console.error(error)
    }
  }
  useEffect(() => {
    if (experienceList && experienceGroupList) {
      const filteredExperiences = group 
        ? experienceList.filter(experienceListItem => experienceListItem.product_experience_group_id === group.group.id)
        : experienceList.filter(experienceListItem => !experienceListItem.product_experience_group_id);
      const filteredExperienceGroups = group 
        ? experienceGroupList.filter(groupListItem => groupListItem.group_id === group.group.id)
        : experienceGroupList.filter(groupListItem => !groupListItem.group_id);
      let newLocalList = [
        ...filteredExperiences.map(experienceListItem => ({
          type: 'products_experiences',
          data: experienceListItem,
          order: experienceListItem.order,
          id: experienceListItem.shared_experiences_id 
            ? 'product_imported_experience_' + experienceListItem.products_experiences_id
            : 'product_experience_' + experienceListItem.products_experiences_id,
          products_experiences_id: experienceListItem.products_experiences_id,
          hover: false,
          area: null,
        })),
        ...filteredExperienceGroups.map(groupListItem => ({
          type: 'product_experience_group',
          data: groupListItem,
          order: groupListItem.order,
          id: groupListItem.shared_experiences_id 
            ? 'product_imported_group-' + groupListItem.id
            : 'product_experience_group-' + groupListItem.id,
          group_id: groupListItem.id,
          hover: false,
          area: null,
        })),
      ];
      newLocalList = newLocalList.sort(compare);
      setLocalList(newLocalList);
    }
  }, [experienceList, experienceGroupList, group]);
  useEffect(() => {
    if (experienceGroupList && experienceList) {
      fetchInsights();
    }
  }, [group, experienceGroupList, experienceList]);
  return (
    <>
      <Flex
        flexDirection={"column"}
        height={((localList && localList.length > 0) ? 'fit-content' : '100%')}
      >
        <ExperiencesInProductListHeader refreshList={refresh} />
        {(lists) && (
          <>
            {(fetchingInsights || hasList) &&
              <Divider />
            }
            <Flex
              pt={(fetchingInsights || hasList) ? 3 : 0}
              w={"100%"}
            >
              {fetchingInsights && (
                <Flex w={"100%"} pr={3} pb={3}>
                  <Skeleton w={"100%"} height={"333px"} />
                </Flex>
              )}
              {(!fetchingInsights && hasList) && (
                <InsightTab
                  lists={lists}
                  onSetAsOutdated={fetchInsights}
                />
              )}
            </Flex>
          </>
        )}
        <Divider />
        <Flex
          flexDirection={"column"}
          flex="1"
          overflow={"auto"}
        >
          {isFetchingExperiences && (
            <Stack gap={1} p={3} spacing={2} backgroundColor={'white'}>
              <Skeleton height='50px' />
              <Skeleton height='50px' />
              <Skeleton height='50px' />
            </Stack>
          )}
          {(!isFetchingExperiences && (!localList || localList.length === 0)) && (
            <Flex
              p={3}
              alignItems={'center'}
              justifyContent={'center'}
              flexDirection={'column'}
              gap={2}
              flex="1"
            >
              <Text
                color="text.medium.grey"
                fontSize={"12px"}
              >No experience so far</Text>
              {rights.can_update &&
                <ExperiencesInProductListMenu 
                  hasExperiences={(experienceList || experienceGroupList)}
                  group={group}
                  onNew={async () => {
                    await refresh();
                    if (refreshSharedExperienceList && typeof refreshSharedExperienceList === 'function') {
                      await refreshSharedExperienceList();
                    }
                  }}
                />
              }
            </Flex>
          )}
          <Flex
            flexDirection={"column"}
            overflow={"auto"}
          >
            {(!isFetchingExperiences && localList) && localList.map((item, i) => {
              return (
                <Flex
                  flexDirection={"column"}
                  key={item.products_experiences_id || item.id || i}
                  onDragStart={() => {
                    setDraggingItem(item);
                  }}
                  onDragOver={(e) => {
                    e.preventDefault();
                    
                    if (!draggingItem) return;
                    
                    let draggableItem;
                    if(e.target.draggable) {
                      draggableItem = e.target;
                    } else {
                      let iterableElement = e.target;
                      while(iterableElement.parentElement && !draggableItem) {
                        if(iterableElement.draggable) {
                          draggableItem = iterableElement;
                        }
                        iterableElement = iterableElement.parentElement;
                      }
                    }
                    
                    if(draggableItem) {
                      const box = draggableItem.getBoundingClientRect();
                      let newArea;
                      
                      if (item.type === 'products_experiences') {
                        newArea = e.clientY <= box.top + (box.height * 0.5) ? 'border-top' : 'border-bottom';
                      } else if (item.type === 'product_experience_group') {
                        if (e.clientY <= box.top + (box.height * (1/3))) {
                          newArea = 'border-top';
                        } else if (e.clientY >= box.top + (box.height * (2/3))) {
                          newArea = 'border-bottom';
                        } else {
                          newArea = 'middle';
                        }
                      }
                      
                      const currentItem = localList.find(listItem => listItem.id === item.id);
                      const needsUpdate = !currentItem?.hover || currentItem?.area !== newArea;
                      
                      if (needsUpdate) {
                        const newLocalList = localList.map((newLocalListItem) => {
                          if (newLocalListItem.id === item.id) {
                            return {
                              ...newLocalListItem,
                              hover: true,
                              area: newArea
                            };
                          } else {
                            return {
                              ...newLocalListItem,
                              hover: false,
                              area: null
                            };
                          }
                        });
                        setLocalList(newLocalList);
                      }
                    }
                  }}
                  onDragEnd={onDragEnd}
                  draggable="true"
                  onClick={(e) => {
                    if (item.type === 'product_experience_group') {
                      navigate(`/products/${product.id}?group-id=${item.data.id}`);
                    } else {
                      navigate(`/experiences/${item.data.id}`);
                    }
                  }}
                  cursor={"pointer"}
                >
                  {(i > 0 && !item.hover) && <Divider style={{ pointerEvents: 'none' }} />}
                  {(item.hover && item.area === 'border-top') && <Divider style={{ pointerEvents: 'none' }} bg={"fill.purple"} h={"2px"} />}
                  {item.type === 'products_experiences' &&
                    <>
                      <ExperiencesInProductListItem
                        productId={productId}
                        experience={item.data}
                      />
                    </>
                  }
                  {item.type === 'product_experience_group' &&
                    <ExperienceGroupInProductListItem
                      dragHover={(item.hover && item.area === 'middle' && (draggingItem && (draggingItem.type === 'products_experiences' || draggingItem.type === 'product_experience_group')))}
                      productId={productId}
                      experienceGroup={item.data}
                    />
                  }
                  {(item.hover && item.area === 'border-bottom') && <Divider style={{ pointerEvents: 'none' }} bg={"fill.purple"} h={"2px"} />}
                </Flex>
              )
            })}
          </Flex>
        </Flex>
      </Flex >
    </>
  );
}
